
import React from "react";


import { connect } from "react-redux";

import history from "../../auth/history";
import './Subtransaction.css';







class AccountReview extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

	

    componentDidMount(){


       
	}
	componentWillUnmount(){
    }



    render(){
    
    return(
                          
        <div class="accountreview">
        <div class="row">
            <div class="col-12 col-md-5">
                <div class="bankdtl">
                    {/* <img src="images/icici-bank.png" alt="bank"> */}
                    <h5>Ramesh Narayan Swamy</h5>
                    <p>ICICI Bank Ltd</p>
                </div>
            </div>
            
            <div class="col-6 col-md-4">
                <div class="bankdtl">
                    <h5>Account Number</h5>
                    <p>1234567890243</p>
                </div>
            </div>
            
            <div class="col-6 col-md-3">
                <div class="bankdtl rtxt">
                    <h5>IFSC Code</h5>
                    <p>ICICI0003236</p>
                </div>
            </div>
            
            <div class="col-12">
                <hr/>
            </div>
            
            <div class="col-12 col-md-5">
                <div class="bankdtl">
                    {/* <img src="images/user-3.jpg" alt="bank"> */}
                    <h5>Sender Name</h5>
                    <p>Ramesh Swamy -9898989898</p>
                </div>
            </div>
            
            <div class="col-6 col-md-4">
                <div class="bankdtl">
                    <h5>Order ID</h5>
                    <p>FINX1234567890</p>
                </div>
            </div>
            
            <div class="col-6 col-md-3">
                <div class="bankdtl rtxt">
                    <h5>Date & Time</h5>
                    <p>22-05-2020 10:24:46</p>
                </div>
            </div>
        </div>
    </div>
);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone}}
	) => ({
		errorMessage,loginErrorMessage,phone
});

export default connect(mapStateToProps, null)(AccountReview);